import React, { useState, useEffect, Fragment } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import Badge from 'components/Badge/Badge';

import { Assignment, Create, Close, Add, BeenhereRounded } from '@material-ui/icons';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import { wsGet, wsGetAll } from 'services/WService.js';

import ModalSubFamily from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import { useParams } from 'react-router-dom';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const subFamilyTableColumns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Código', accessor: 'code' },
  { Header: 'Descripción', accessor: 'description' },
  { Header: 'Nombre familia', accessor: 'family' },
  { Header: 'Estado', accessor: 'state' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function SubFamily(props) {
  const { familyId } = useParams();
  const classes = useStyles();
  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [line, setLine] = useState();
  const [family, setFamily] = useState();
  const [subFamilies, setSubFamilies] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function loadSubFamilies() {
    setDataLoading(true);
    let response = await wsGetAll('logi/sub-family');
    setDataLoading(false);
    if (response.success) setSubFamilies(response.data);
  }

  async function loadFamily() {
    setDataLoading(true);
    let response = await wsGet('logi/family', familyId);
    setDataLoading(false);    
    if(!response.success) return;
    let { sub_families, line, ...family } = response.data;
    setSubFamilies(sub_families);
    setFamily(family);
    setLine(line);
  }

  useEffect(() => {
    if(familyId === undefined){
      loadSubFamilies();
    }else{
      loadFamily();
    }
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <ModalSubFamily
        model={model}
        setOpen={setOpen}
        showNotify={showNotify}
        reload={loadSubFamilies}
      />

      <GridItem xs={12}>
        <Card>

        {familyId === undefined ? (
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.LOGI_SUB_FAMILIES_STORE}
              component={
                <CardIcon color="primary">
                  <BeenhereRounded style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de Subfamilias {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
        ) : (
          <CardHeader>
            {line !== undefined ? (
                <Fragment>
                  <Badge color="info">{line.category.business_partner.CardName}</Badge>
                  <Badge color="primary">Categoria {line.category.description}</Badge>
                  <Badge color="success">Línea {line.description}</Badge>
                </Fragment>
              ) : undefined}
            <h3 className={classes.cardIconTitle}>
              {family === undefined ? 'Cargando Familia...' : `Familia ${family.description}`}
            </h3>
          </CardHeader>
        )}

          <CardBody>
            {family !== undefined ? <h5>SubFamilias</h5> : undefined}
            <ReactTable
              excelName="Subfamilias"
              defaultWidth={1000}
              indexRow={[0, 1, 4, 5]}
              widthRow={[120, 120, 200, 5]}
              columns={subFamilyTableColumns}
              data={subFamilies.map((subFamily, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.LOGI_SUB_FAMILIES_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color="info"
                          className="like"
                          onClick={() => setOpen(subFamily)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.LOGI_SUB_FAMILIES_DELETED}>
                        <ButtonDelete
                          entity="logi/sub-family"
                          id={subFamily.id}
                          reload={loadSubFamilies}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  code: subFamily.code,
                  description: subFamily.description,
                  family: subFamily.logi_family_description,
                  state: subFamily.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: ''
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
